export default {
  bot: 'Bot',
  name: 'Queue',
  waitingTickets: 'Waiting Tickets',
  openedTickets: 'Opened Tickets',
  averageResponseTime: 'Average Response Time',
  averageAttendanceTime: 'Average Attendance Time',
};
